import { createSlice } from "@reduxjs/toolkit";
import ROLES_LIST from "../../RoleList.mjs";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: null,
    error: null,
    selectedRole: localStorage.getItem("selectedRole")
      ? Number(localStorage.getItem("selectedRole"))
      : null,
    selectedSchoolUuid: localStorage.getItem("selectedSchoolUuid") || null,
  },
  reducers: {
    setCredentials: (state, action) => {
      const { user, accessToken } = action.payload;
      state.user = user;
      state.token = accessToken;
      state.error = null;

      // Validate existing selectedRole against user's actual roles
      if (
        state.selectedRole &&
        user?.roles &&
        !user.roles.includes(state.selectedRole)
      ) {
        state.selectedRole = null;
      }

      // Automatically set default role if none is selected
      if (!state.selectedRole && user?.roles?.length > 0) {
        const priorityOrder = [
          ROLES_LIST.YAYASAN,
          ROLES_LIST.TENDIK,
          ROLES_LIST.BENDAHARA,
          ROLES_LIST.KEPSEK,
          ROLES_LIST.WAKUR,
          ROLES_LIST.WALIKELAS,
          ROLES_LIST.TATAUSAHA,
          ROLES_LIST.GURU,
        ];

        let defaultRole = user.roles[0]; // Fallback to first role

        for (const priorityRole of priorityOrder) {
          if (user.roles.includes(priorityRole)) {
            defaultRole = priorityRole;
            break;
          }
        }

        state.selectedRole = defaultRole;
        localStorage.setItem("selectedRole", defaultRole);
      }
    },
    setAuthError: (state, action) => {
      state.error = action.payload;
    },
    clearAuthError: (state) => {
      state.error = null;
    },
    resetReducer: (state, action) => {
      state.user = null;
      state.token = null;
      state.error = null;
      state.selectedRole = null;
      localStorage.removeItem("selectedRole");
    },
    setRole: (state, action) => {
      state.selectedRole = action.payload;
      localStorage.setItem("selectedRole", action.payload);
    },
    setSchoolUuid: (state, action) => {
      state.selectedSchoolUuid = action.payload;
      if (action.payload) {
        localStorage.setItem("selectedSchoolUuid", action.payload);
        console.log(
          "[authSlice] Wrote selectedSchoolUuid to localStorage:",
          action.payload,
        );
      } else {
        localStorage.removeItem("selectedSchoolUuid");
        console.log("[authSlice] Removed selectedSchoolUuid from localStorage");
      }
    },
  },
});

export const {
  setCredentials,
  setAuthError,
  clearAuthError,
  resetReducer,
  setRole,
  setSchoolUuid,
} = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentToken = (state) => state.auth.token;
export const selectAuthError = (state) => state.auth.error;
export const selectSelectedSchoolUuid = (state) =>
  state.auth.selectedSchoolUuid;
export const selectSelectedRole = (state) => state.auth.selectedRole;
